/**
 * Created by Ondra on 10.11.2016.
 */
import React from 'react';

const CloseButton = (props) => (
    <div className={`boxBtn-inner`}>
      <svg className={`shape shape-times ${!!props.className ? props.className : ''}`}>
        <use xlinkHref={`#shape-times`}></use>
      </svg>
    </div>
);

export default CloseButton;



// WEBPACK FOOTER //
// ./src/browser/components/buttons/CloseButton.js